export default "__VITE_ASSET__BV9eNuWM__"